export default __webpack_public_path__ + "static/media/Nasdaq-N-Navbar.9b24721f.svg";